import $ from 'jquery';
import { mark, unmark } from './api';

export default function bind() {
  $('a.check').on('click', function(evt) {
    evt.preventDefault();

    const $elt = $(evt.currentTarget);
    const interventionId = $elt.attr('data-id');
    const marked = $elt.hasClass('on');
    if (marked) {
      unmark(interventionId).then(resp => handleReturn(resp, $elt));
    } else {
      mark(interventionId).then(resp => handleReturn(resp, $elt));
    }
  });
}

function handleReturn(checked, $elt) {
  if (checked === 'true') {
    $elt.removeClass('off');
    $elt.addClass('on');
    const $image = $elt.find('i');
    $image.removeClass('circle');
    $image.removeClass('outline');
    $image.removeClass('check');
    $elt.addClass('orange');
    $elt.addClass('radio');
  } else {
    $elt.addClass('off');
    $elt.removeClass('on');
    const $image = $elt.find('i');
    $image.addClass('circle');
    $image.addClass('outline');
    $image.addClass('check');
    $elt.removeClass('orange');
    $elt.removeClass('radio');
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/comments/index.js